<template>
  <LayoutPage>
    <template #aside>
      <CompositeAsideCard title="Valorisation des déchets" subtitle="Performance de tri du mois précédent"
        key-info-label="Performance de tri" :key-info="store.getWaste.waste_sorting_rate_monthly.toString() + '%'"
        :tip-description="['Tri des déchets : soyons attentifs tous ensemble !']" tip-green-background>
        <template #key-info-icon>
          <IconWasteWhite />
        </template>
        <template #tip-icon>
          <IconEyeGreen />
        </template>
      </CompositeAsideCard>
    </template>
    <template #content>
      <div class="waste-management">
        <CompositeChartSection class="waste-management-chart-bars" title="Taux de tri en %" :chips="[{ title: new Date().getFullYear().toString(), backgroundColor: '#2271b9' }, { title: (new Date().getFullYear() - 1).toString(), backgroundColor: '#7c888f' }]">
          <ChartBars v-if="isMounted"
            :datasets="[{ backgroundColor: '#2271b9', data: store.getWaste.waste_sorting_rate_yearly_current }, {backgroundColor: '#737373', data: store.getWaste.waste_sorting_rate_yearly_before}]"
            yAxisLegend="Performance de tri en %" :max="100" 
            :objective-line="{ value: 70, label: 'Objectif 70%', color: '#7bbf4a' }"
            :moving-average-line="store.getWaste.waste_sorting_rate_moving_average" />

        </CompositeChartSection>
        <CompositeChartSection class="waste-management-chart-stacked-bars" title="Tonnage par famille de déchets">
          <ChartStackedBar v-if="isMounted" :datasets="getDataset()" total />
        </CompositeChartSection>
      </div>
    </template>
  </LayoutPage>
</template>

<script lang="ts" setup>
import ChartBars from '@/components/common/charts/ChartBars.vue'
import ChartStackedBar from '@/components/common/charts/ChartStackedBar.vue'
import CompositeAsideCard from '@/components/composite/CompositeAside.vue'
import CompositeChartSection from '@/components/composite/CompositeChartSection.vue'
import IconEyeGreen from '@/components/icons/IconEyeGreen.vue'
import IconWasteWhite from '@/components/icons/IconWasteWhite.vue'
import LayoutPage from '@/components/layout/LayoutPage.vue'
import { useDataStore } from '@/stores/store_data'
import { onMounted, ref } from 'vue'

const store = useDataStore()
const isMounted = ref<boolean>(false)

onMounted(() => {
  store.fetchLGCData().then(() => {
    isMounted.value = true
  })
})

function getDataset() {
  return [
    { label: 'Matières organiques', backgroundColor: '#7bbf4a', data: [store.getWaste.waste_tonnage_by_type.MAT_ORGA], class: 'organic' },
    { label: 'DIB', backgroundColor: '#0072ce', data: [store.getWaste.waste_tonnage_by_type.DECH_NDG], class: 'mix' },
    { label: 'DIV', backgroundColor: '#41693d80', data: [store.getWaste.waste_tonnage_by_type.DECH_REC], class: 'recyclable' },
    { label: 'Verres', backgroundColor: '#73737380', data: [store.getWaste.waste_tonnage_by_type.VERRE], class: 'glass' },
    { label: 'Papiers et cartons', backgroundColor: '#0072ce80', data: [store.getWaste.waste_tonnage_by_type.PC], class: 'paper' },
  ]
}





</script>

<style scoped lang="scss">
.waste-management {
  display: flex;
  width: 100%;
  height: 100%;
  max-height: 100%;
  gap: var(--spacer);

  &-chart {
    &-stacked-bars {
      width: 30%;
    }

    &-bars {
      width: 60%;
    }
  }
}
</style>
